import React from 'react'
import _ from 'lodash'
import { RadioButton } from 'primereact/radiobutton'
import { normalizeComponentLabel } from './form-builder-utils'

const resolveTitle = (componentInfo) => {
  let campo = _.get(componentInfo, 'campo', '')
  if (_.isEmpty(campo)) {
    return null
  }
  campo = campo.replaceAll('rb_', '')
  return (
    <div className="p-col-12" style={{ marginTop: '10px' }}>
      <label>{normalizeComponentLabel(campo)}</label>
    </div>
  )
}

const resolveFieldName = (componentInfo) => {
  return _.get(componentInfo, 'campo', '').replaceAll('rb_', '')
}

export const formBuildRadio = ({ componentInfo, messages, record, onChange }) => {
  return (
    <div className="p-grid form-group">
      {resolveTitle(componentInfo)}
      {_.get(componentInfo, 'valor', '')
        .split(',')
        .map((row, i) => (
          <div className="p-col-12">
            <RadioButton
              value={row}
              name={resolveFieldName(componentInfo)}
              onChange={(e) => onChange(resolveFieldName(componentInfo), _.get(e, 'value'))}
              checked={record[resolveFieldName(componentInfo)] === row}
            />
            <label className="label" style={{ marginLeft: '5px' }}>
              {normalizeComponentLabel(row)}
            </label>
          </div>
        ))}
    </div>
  )
}
